import { supabase } from "@/integrations/supabase/client";

/**
 * Emails whose accounts bypass all client-side stream restrictions
 * (1-stream-per-track/24h IP cap, daily fan stream cap, velocity limits).
 * Self-streaming, sponsor wallet, and payment cap logic are NOT bypassed.
 */
export const UNLIMITED_STREAM_EMAILS: string[] = ["solo.magaji@gmail.com"];

const normalized = new Set(
  UNLIMITED_STREAM_EMAILS.map((e) => e.trim().toLowerCase()),
);

export function isUnlimitedStreamEmail(email?: string | null): boolean {
  if (!email) return false;
  return normalized.has(email.trim().toLowerCase());
}

export function isUnlimitedStreamUser(
  user?: { email?: string | null } | null,
): boolean {
  return isUnlimitedStreamEmail(user?.email ?? null);
}

let cachedEmail: string | null | undefined;
let cachedAt = 0;

/**
 * Fetch current auth user email (cached for 60s) and check whitelist.
 * Safe to call from utils that don't have user context handy.
 */
export async function isCurrentUserUnlimitedStream(): Promise<boolean> {
  try {
    const now = Date.now();
    if (cachedEmail === undefined || now - cachedAt > 60_000) {
      const { data } = await supabase.auth.getUser();
      cachedEmail = data.user?.email ?? null;
      cachedAt = now;
    }
    return isUnlimitedStreamEmail(cachedEmail);
  } catch {
    return false;
  }
}
